import script from "./Table_Gene.vue?vue&type=script&setup=true&lang=js"
export * from "./Table_Gene.vue?vue&type=script&setup=true&lang=js"

import "./Table_Gene.vue?vue&type=style&index=0&id=4564c8d4&lang=css"

const __exports__ = script;

export default __exports__